var indentStyle = {"indentZero":"_39sR0","indentOne":"_6N7mj","indentTwo":"iI0lv","indentThree":"NelJS","indentFour":"TXa2i","indentFive":"ux1OJ","indentSix":"_1eGpa"};

export { indentStyle as i };
//# sourceMappingURL=indentation-66ff6e79.js.map
